import { Box, Stack, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC } from "react";
import { DateLine } from "web_myplann/NotificationCenter/Components/DateLine";
import { TimelineItemText } from "web_myplann/NotificationCenter/Components/TimelineItemText";
import { TimelineRowButton } from "web_myplann/NotificationCenter/Components/TimelineRowButton";
import { UnreadDot } from "web_myplann/NotificationCenter/Components/UnreadDot";
import type { TimelineItemLayoutProps } from "web_myplann/NotificationCenter/Types/TimelineItemLayoutProps";
import { CategoryIcon } from "web_myplann/Shared/Components/CategoryIcon";

export const TimelineItemLegacyLayout: FC<TimelineItemLayoutProps> = ({
	item,
	dateLine,
	secondaryDateLine,
	unread = false,
	showChevron = false,
	disabled = false,
	onClick,
	isLast = false,
	"data-testid": dataTestId,
}) => {
	const { palette, spacingTokens } = useTheme();

	return (
		<TimelineRowButton
			isLast={isLast}
			backgroundColor={unread ? palette.blue[50] : undefined}
			disabled={disabled}
			onClick={onClick}
			sx={{
				position: "relative",
				py: spacingTokens.md,
				pl: 2.2,
				pr: spacingTokens.lg,
			}}
			data-testid={dataTestId}
		>
			{unread && <UnreadDot color={palette.secondary.main} inset={6} />}

			<Stack
				direction="row"
				gap={spacingTokens.lg}
				width="100%"
				alignItems="flex-start"
			>
				<Box pt={spacingTokens.xs}>
					<CategoryIcon item={item} />
				</Box>

				<TimelineItemText item={item} unread={unread} />

				<Stack direction="row" alignItems="center" gap={0.6} flexShrink={0}>
					<Stack alignItems="flex-end">
						<DateLine text={dateLine} />
						{secondaryDateLine ? <DateLine text={secondaryDateLine} /> : null}
					</Stack>
					{showChevron ? (
						<ChevronRight size={20} color={palette.grey[400]} />
					) : null}
				</Stack>
			</Stack>
		</TimelineRowButton>
	);
};
